export const STATUS_TYPE = {
  1: { type: 'info', content: '进行中' },
  2: { type: 'default', content: '利息待发放' },
  4: { type: 'danger', content: '已违约' },
  5: { type: 'success', content: '利息已发放' },
  6: { type: 'warning', content: '利息发放失败' }
};
